<script setup>
import { onMounted, computed, watch, ref } from 'vue';
import { useProjeto } from '@/modules/projeto/composables/useProjeto';

const { rubricas, carregarRubricasDisponiveis } = useProjeto();

const props = defineProps({
    projetoId: String,
    tipoSolicitacaoId: {
        type: Number,
        default: null
    },
    rubricaId: {
        type: Number,
        default: null
    },
    erro: {
        type: String,
        default: null
    },
    modelValue: {
        type: Number,
        default: null
    },
})

const emit = defineEmits(['update:modelValue', 'change', 'reset']);

const options = computed(() => {
    if (!rubricas.value) {
        return [];
    }
    return rubricas.value.rubricas || [];
});

const desabilitado = computed(() => options.value.length === 1);

function selecionarSeUnico() {
    if (options.value.length === 1) {
        rubricaSelecionada.value = options.value[0];
    }
}

watch(
    () => props.tipoSolicitacaoId,
    async (newValue) => {
        if (newValue) {
            emit('reset', null);
            emit('change', null);
            await carregarRubricasDisponiveis(props.projetoId, newValue);
            selecionarSeUnico();
        }
    }
);

const rubricaSelecionada = ref();

watch(
    () => props.modelValue,
    async (newValue) => {
        if (newValue && newValue !== rubricaSelecionada.value?.id) {
            await carregarRubricasDisponiveis(props.projetoId, props.tipoSolicitacaoId);
            rubricaSelecionada.value = options.value.find(rubrica => rubrica.id === newValue) || null;
            selecionarSeUnico();
        }

        if (!newValue){
            emit('reset');
            rubricaSelecionada.value = null;
        }
    },
    { immediate: true }
);

watch(
    () => rubricaSelecionada.value,
    (newValue) => {
        if(newValue){
            emit('update:modelValue', newValue?.id);
            emit('change', newValue?.codigo);
        }
        if(!newValue){
            rubricaSelecionada.value = null;
            emit('reset');
            emit('update:modelValue', null);
        }
    }
);

onMounted(async () => {
    if (props.tipoSolicitacaoId) {
        await carregarRubricasDisponiveis(props.projetoId, props.tipoSolicitacaoId);
        selecionarSeUnico();
    }
});
</script>

<template>
    <div class="field mb-2 col-12">
        <SmallTitle titulo="Rubrica Financeira" :obrigatorio="true" />
        <Dropdown :options="options" v-model="rubricaSelecionada" optionLabel="nome"
            emptyFilterMessage="Nenhuma rubrica encontrada" :class="{ 'p-invalid': props.erro }"
            placeholder="Selecione a rubrica financeira" :showClear="!desabilitado" :disabled="desabilitado">
        </Dropdown>
        <SmallError v-if="props.erro" :error="props.erro" />
    </div>
</template>